import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=cf7f9cbc"
import script from "./CollectionCard.vue?vue&type=script&lang=ts"
export * from "./CollectionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports